import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const BREAKPOINT_SM = "660px";

const MODAL_THEMES = {
  desktop: {
    classicBlueHeader: {
      closeButtonWrapper: {
        alignItems: "center",
        backgroundColor: colors.ink,
        padding: "18px",
        position: "static"
      }
    },
    default: {
      closeButtonWrapper: {
        alignItems: "stretch",
        backgroundColor: "transparent",
        justifyContent: "flex-start",
        padding: "25px",
        position: "absolute"
      }
    },
    lightBox: {
      closeButtonWrapper: {
        alignItems: "stretch",
        backgroundColor: "transparent",
        justifyContent: "flex-end",
        padding: "25px 25px 0",
        position: "absolute"
      }
    }
  },
  mobile: {
    classicBlueHeader: {
      bodyWrapper: {
        display: "flex",
        height: "100%"
      },
      closeButtonWrapper: {
        padding: "18px"
      },
      contentWrapper: {
        height: "100%",
        margin: "0",
        top: "0"
      }
    },
    default: {
      bodyWrapper: {
        display: "flex",
        height: "100%"
      },
      closeButtonWrapper: {
        padding: "18px"
      },
      contentWrapper: {
        height: "100%",
        margin: "0",
        top: "0"
      }
    },
    lightBox: {
      bodyWrapper: {
        display: "initial",
        height: "initial"
      },
      closeButtonWrapper: {
        padding: ""
      },
      contentWrapper: {
        height: "auto",
        margin: "10px 20px 0",
        top: ""
      }
    }
  }
};

const BodyWrapper = styled.section`
  @media screen and (max-width: ${BREAKPOINT_SM}) {
    display: ${({ theme }) =>
      MODAL_THEMES.mobile[theme.name].bodyWrapper.display};
    height: ${({ theme }) =>
      MODAL_THEMES.mobile[theme.name].bodyWrapper.height};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const CloseButtonWrapper = styled.div`
  align-items: ${({ theme }) =>
    MODAL_THEMES.desktop[theme.name].closeButtonWrapper.alignItems};
  background-color: ${({ theme }) =>
    MODAL_THEMES.desktop[theme.name].closeButtonWrapper.backgroundColor};

  display: flex;
  justify-content: ${({ isBackAvailable, theme }) =>
    isBackAvailable
      ? "space-between"
      : MODAL_THEMES.desktop[theme.name].closeButtonWrapper.justifyContent};
 };

  padding: ${({ theme }) =>
    MODAL_THEMES.desktop[theme.name].closeButtonWrapper.padding};
  position: ${({ theme }) =>
    MODAL_THEMES.desktop[theme.name].closeButtonWrapper.position};
  width: 100%;

  @media screen and (max-width: ${BREAKPOINT_SM}) {
    padding: ${({ theme }) =>
      MODAL_THEMES.mobile[theme.name].closeButtonWrapper.padding};
    }};
`;

const ContentWrapper = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  left: 50%;
  margin: ${props => `0 0 ${props.top}`};
  position: absolute;
  top: ${props => props.top};
  transform: translateX(-50%);
  ${({ contentWidth }) => (contentWidth ? `width: ${contentWidth}` : null)};

  @media screen and (max-width: ${BREAKPOINT_SM}) {
    display: flex;
    flex-direction: column;
    left: 0;
    height: ${({ theme }) =>
      MODAL_THEMES.mobile[theme.name].contentWrapper.height};
    margin: ${({ theme }) =>
      MODAL_THEMES.mobile[theme.name].contentWrapper.margin};
    top: ${({ theme }) => MODAL_THEMES.mobile[theme.name].contentWrapper.top};
    transform: unset;
  }
`;

const ModalWrapper = styled.div`
  -webkit-overflow-scrolling: touch;
  background-color: rgba(0, 0, 0, 0.22);
  height: 100vh;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: ${props => props.zIndex};

  * {
    box-sizing: border-box;
  }
`;

BodyWrapper.displayName = "BodyWrapper";
CloseButtonWrapper.displayName = "CloseButtonWrapper";
ContentWrapper.displayName = "ContentWrapper";
ModalWrapper.displayName = "ModalWrapper";

export { BodyWrapper, CloseButtonWrapper, ContentWrapper, ModalWrapper };
